export default __webpack_public_path__ + "media/images/banner/banner-20-f9970d147a0210825eaf2bdcf398e2ad.jpg";